/* ================= SIMPLE GALLERY ================= */

let currentIndex = 0;
let itemsPerView = 4;

// Инициализация галереи (полная копия Products Carousel)
document.addEventListener('DOMContentLoaded', function() {
  console.log('🎨 Simple Gallery загружается...');
  
  const gallery = document.getElementById('galleryTrack');
  if (!gallery) {
    console.log('❌ Галерея не найдена!');
    return;
  }
  
  const items = document.querySelectorAll('.gallery-item');
  console.log('✅ Галерея найдена, элементов:', items.length);
  
  // Визуальные и поведенческие настройки (как в Products Carousel)
  gallery.style.cursor = 'grab';
  gallery.style.touchAction = 'pan-y';
  gallery.style.setProperty('touch-action', 'pan-y', 'important');
  
  // Отключаем стандартный drag изображений (как в Products Carousel)
  gallery.querySelectorAll('img').forEach((img) => {
    img.setAttribute('draggable', 'false');
    img.style.userSelect = 'none';
    img.addEventListener('dragstart', (e) => e.preventDefault());
  });

  let startX = 0;
  let startY = 0;
  let isDragging = false;
  let isHorizontal = false;
  let dragStartPosition = 0;
  let storedTransition = '';
  const minSwipe = 20;

  const clampToBounds = (pos) => {
    const wrapperEl = gallery.closest('.gallery-container') || gallery.parentElement;
    const visible = wrapperEl ? wrapperEl.clientWidth : gallery.clientWidth;
    const content = gallery.scrollWidth;
    const maxRight = 0;
    const maxLeft = Math.min(0, visible - content); // отрицательное или 0
    if (pos > maxRight) return maxRight;
    if (pos < maxLeft) return maxLeft;
    return pos;
  };

  // Touch события (как в Products Carousel)
  const onTouchStart = (e) => {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    isDragging = true;
    wasDragging = false; // Сбрасываем флаг
    isHorizontal = false;
    dragStartPosition = currentPosition || 0;
    dragStartTime = Date.now(); // Засекаем время начала
    // Отключаем анимацию на время перетаскивания
    storedTransition = gallery.style.transition || '';
    gallery.style.transition = 'none';
  };
  
  const onTouchMove = (e) => {
    if (!isDragging) return;
    const dx = Math.abs(e.touches[0].clientX - startX);
    const dy = Math.abs(e.touches[0].clientY - startY);
    if (!isHorizontal && dx > 4 && dx > dy) {
      isHorizontal = true;
      wasDragging = true; // Устанавливаем флаг что был drag
    }
    if (isHorizontal) {
      if (e.cancelable) e.preventDefault();
      const delta = e.touches[0].clientX - startX;
      const nextPos = clampToBounds(dragStartPosition + delta);
      currentPosition = nextPos;
      gallery.style.transform = `translateX(${nextPos}px)`;
    }
  };
  
  const onTouchEnd = (e) => {
    if (!isDragging) return;
    // Оставляем позицию как есть — уже следовала за пальцем
    isDragging = false;
    isHorizontal = false;
    dragEndTime = Date.now(); // Засекаем время окончания
    // Возвращаем анимацию после отпускания
    gallery.style.transition = storedTransition || 'transform 0.3s ease-in-out';
  };

  gallery.addEventListener('touchstart', onTouchStart, { passive: true });
  gallery.addEventListener('touchmove', onTouchMove, { passive: false });
  gallery.addEventListener('touchend', onTouchEnd, { passive: true });

  // Mouse события (как в Products Carousel)
  const onMouseDown = (e) => {
    isDragging = true;
    wasDragging = false; // Сбрасываем флаг
    startX = e.clientX;
    startY = e.clientY;
    isHorizontal = false;
    gallery.style.cursor = 'grabbing';
    dragStartPosition = currentPosition || 0;
    dragStartTime = Date.now(); // Засекаем время начала
    e.preventDefault();
    // Отключаем анимацию на время перетаскивания
    storedTransition = gallery.style.transition || '';
    gallery.style.transition = 'none';
  };
  
  const onMouseMove = (e) => {
    if (!isDragging) return;
    const dx = Math.abs(e.clientX - startX);
    const dy = Math.abs(e.clientY - startY);
    if (!isHorizontal && dx > 4 && dx > dy) {
      isHorizontal = true;
      wasDragging = true; // Устанавливаем флаг что был drag
    }
    if (isHorizontal) {
      if (e.cancelable) e.preventDefault();
      const delta = e.clientX - startX;
      const nextPos = clampToBounds(dragStartPosition + delta);
      currentPosition = nextPos;
      gallery.style.transform = `translateX(${nextPos}px)`;
    }
  };
  
  const onMouseUp = (e) => {
    if (!isDragging) return;
    // Оставляем позицию как есть — уже следовала за курсором
    isDragging = false;
    isHorizontal = false;
    gallery.style.cursor = 'grab';
    dragEndTime = Date.now(); // Засекаем время окончания
    // Возвращаем анимацию после отпускания
    gallery.style.transition = storedTransition || 'transform 0.3s ease-in-out';
  };

  // Блокируем клики по изображениям при drag на десктопе (как в Products Carousel)
  let wasDragging = false;
  let dragDistance = 0;
  let dragStartTime = 0;
  let dragEndTime = 0;
  
  gallery.addEventListener('click', (e) => {
    // Проверяем, был ли это drag или обычный клик
    dragDistance = Math.abs(e.clientX - startX);
    const dragDuration = dragEndTime - dragStartTime;
    
    // Блокируем клик если:
    // 1. Расстояние движения больше 10px ИЛИ
    // 2. Время drag больше 200ms ИЛИ  
    // 3. Флаг isDragging был true
    if (dragDistance > 10 || dragDuration > 200 || wasDragging) {
      e.preventDefault();
      e.stopPropagation();
      console.log('Клик заблокирован — был drag, расстояние:', dragDistance, 'время:', dragDuration, 'wasDragging:', wasDragging);
      wasDragging = false; // Сбрасываем флаг
      return false;
    }
    
    // Обработка клика по изображению только если это был настоящий клик
    const img = e.target.closest('img');
    if (img) {
      console.log('Клик по изображению:', img.src);
      openLightbox(img.src);
    }
  }, true);

  gallery.addEventListener('mousedown', onMouseDown);
  document.addEventListener('mousemove', onMouseMove);
  document.addEventListener('mouseup', onMouseUp);
  
  // Добавляем обработчики для кнопок навигации
  const leftBtn = document.querySelector('.gallery-btn.prev');
  const rightBtn = document.querySelector('.gallery-btn.next');
  
  if (leftBtn) {
    leftBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      slideGallery(-1);
    });
  }
  
  if (rightBtn) {
    rightBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      slideGallery(1);
    });
  }
  
  // Сбрасываем позицию на начало при инициализации (как в Products Carousel)
  currentPosition = 0;
  gallery.style.transform = 'translateX(0px)';
  
  // Принудительно устанавливаем позицию (как в Products Carousel)
  setTimeout(() => {
    gallery.style.setProperty('transform', 'translateX(0px)', 'important');
    currentPosition = 0;
    console.log('Позиция gallery принудительно сброшена на 0');
  }, 100);
  
  // Пересчёт при ресайзе (как в Products Carousel)
  window.addEventListener('resize', () => {
    currentPosition = Math.min(0, currentPosition);
    gallery.style.transform = `translateX(${currentPosition}px)`;
  });
  
  // Экспортируем функцию глобально (как в Products Carousel)
  window.slideGallery = slideGallery;
  
  console.log('Simple Gallery инициализирован как Products Carousel с полным функционалом');
});


// Переменные для позиции (как в Products Carousel)
let currentPosition = 0;

// Предыдущий слайд (как в Products Carousel)
function galleryPrev() {
  slideGallery(-1);
}

// Следующий слайд (как в Products Carousel)
function galleryNext() {
  slideGallery(1);
}

// Функция смены слайдов (точно как в Products Carousel)
function slideGallery(direction) {
  console.log('slideGallery вызвана с направлением:', direction);
  const gallery = document.getElementById('galleryTrack');
  if (!gallery) {
    console.log('Gallery не найден');
    return;
  }
  
  const wrapper = gallery.closest('.gallery-container') || gallery.parentElement;
  if (!wrapper) {
    console.log('Wrapper не найден');
    return;
  }
  
  const GAP = parseInt(getComputedStyle(gallery).gap || '10', 10);
  const items = Array.from(gallery.children).filter((n) => n.nodeType === 1);
  console.log('Количество элементов в галерее:', items.length);
  if (items.length === 0) return;
  
  const first = items[0];
  const step = first.getBoundingClientRect().width + GAP;
  const totalWidth = items.reduce((w, el, idx) => {
    const r = el.getBoundingClientRect();
    return w + r.width + (idx < items.length - 1 ? GAP : 0);
  }, 0);
  const wrapperWidth = wrapper.getBoundingClientRect().width;
  
  console.log('Шаг:', step, 'Общая ширина:', totalWidth, 'Ширина wrapper:', wrapperWidth);
  
  // Возвращаем логику carousel
  currentPosition += direction * -step;
  
  // Правильный расчёт границ
  const maxRight = 0; // Правая граница (начало)
  const maxLeft = -(totalWidth - wrapperWidth); // Левая граница (конец)
  
  console.log('Границы:', { maxRight, maxLeft, currentPosition });
  
  // Ограничиваем позицию
  if (currentPosition > maxRight) currentPosition = maxRight;
  if (currentPosition < maxLeft) currentPosition = maxLeft;
  console.log('Новая позиция:', currentPosition);
  gallery.style.transform = `translateX(${currentPosition}px)`;
  
  // Проверяем, что transform применился
  console.log('Применённый transform:', gallery.style.transform);
}

// Открытие lightbox
function openLightbox(src) {
  console.log('🔍 Открытие lightbox для:', src);
  
  const lightbox = document.getElementById('lightbox');
  const lightboxImg = document.getElementById('lightbox-img');
  
  if (!lightbox || !lightboxImg) {
    console.log('❌ Lightbox элементы не найдены!');
    return;
  }
  
  lightboxImg.src = src;
  lightbox.style.display = 'flex';
  
  // Блокируем скролл страницы
  document.body.style.overflow = 'hidden';
}

// Закрытие lightbox
function closeLightbox() {
  console.log('❌ Закрытие lightbox');
  
  const lightbox = document.getElementById('lightbox');
  if (!lightbox) return;
  
  lightbox.style.display = 'none';
  
  // Разблокируем скролл страницы
  document.body.style.overflow = 'auto';
}

// Закрытие lightbox по клику на фон
document.addEventListener('click', function(e) {
  const lightbox = document.getElementById('lightbox');
  if (lightbox && lightbox.style.display === 'flex' && e.target === lightbox) {
    closeLightbox();
  }
});

// Закрытие lightbox по Escape
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    closeLightbox();
  }
});

// Глобальные функции для тестирования
window.testGallery = function() {
  console.log('🧪 ТЕСТ ГАЛЕРЕИ:');
  console.log('- Трек галереи:', document.getElementById('galleryTrack'));
  console.log('- Элементы:', document.querySelectorAll('.gallery-item').length);
  console.log('- Текущая позиция:', currentIndex);
  console.log('- Элементов на экран:', itemsPerView);
  console.log('- Кнопки:', document.querySelectorAll('.gallery-btn').length);
};

window.testLightbox = function() {
  console.log('🧪 ТЕСТ LIGHTBOX:');
  console.log('- Lightbox элемент:', document.getElementById('lightbox'));
  console.log('- Lightbox изображение:', document.getElementById('lightbox-img'));
  console.log('- openLightbox функция:', typeof window.openLightbox);
  console.log('- closeLightbox функция:', typeof window.closeLightbox);
};

console.log('✅ Simple Gallery загружен успешно!');
